module.exports = __webpack_public_path__ + "static/media/arrowIconRight.c2a14e02.svg";